import { t } from "i18next";
import styles from "./LoadButton.module.scss";

type Props = {
	loadCount: number;
	onClick: () => void;
}

const LoadButton: React.FC<Props> = ({
	loadCount,
	onClick
}) => {
	return (
		<button 
			className={styles.loadMoreButton}
			onClick={onClick}
		>
			{t(
				`loadButton.${
					(loadCount === 0 || loadCount >= 5) ? "loadPlural" : "loadSingular"
				}`, 
				{ count: loadCount }
			)}
		</button>
	)
}

export default LoadButton;